<app-grid (itemsChange)="onExchange($event)" (fromPreview)="true" #gridChild></app-grid>